import { render, staticRenderFns } from "./precision.vue?vue&type=template&id=53eaa7b8&scoped=true"
import script from "./precision.vue?vue&type=script&lang=js"
export * from "./precision.vue?vue&type=script&lang=js"
import style0 from "./precision.vue?vue&type=style&index=0&id=53eaa7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eaa7b8",
  null
  
)

export default component.exports